import React, { useEffect, useState } from 'react';

const PaypalButton = ({ selectedPackage, onPaymentStatus }) => {
    const [paypalButtonRendered, setPaypalButtonRendered] = useState(false); // Estado para verificar si el botón ya fue renderizado

    useEffect(() => {
        if (window.paypal && selectedPackage && !paypalButtonRendered) {
            window.paypal.Buttons({
                createOrder: (data, actions) => {
                    return actions.order.create({
                        purchase_units: [{
                            amount: {
                                value: selectedPackage.price.toFixed(2), // Precio dinámico del paquete
                                currency_code: 'USD',
                            },
                            description: `Compra de ${selectedPackage.packageName}`, // Descripción dinámica
                        }]
                    });
                },
                onApprove: (data, actions) => {
                    return actions.order.capture().then(function (details) {
                        alert('Pago realizado por ' + details.payer.name.given_name);
                        // Al pago exitoso, actualizamos el estado en el componente principal
                        onPaymentStatus('success');
                        console.log('Pago exitoso:', details);
                    });
                },onCancel: (data) => {
                    console.log('Pago cancelado:', data);
                    alert("El pago fue cancelado.");
                    // Si el usuario cancela, puedes manejarlo según sea necesario
                    onPaymentStatus('failed');
                },
                onError: (err) => {
                    console.log("Error en el pago: ", err);
                    alert("Hubo un problema con el pago.");
                    // Si el pago falla, actualizamos el estado en el componente principal
                    onPaymentStatus('failed');
                },
                
            }).render('#paypal-button-container'); // Renderiza el botón en el contenedor

            // Actualizamos el estado para indicar que el botón ya fue renderizado
            setPaypalButtonRendered(true);
        }
    }, [selectedPackage, onPaymentStatus, paypalButtonRendered]);

    return <div id="paypal-button-container"></div>;
};

export default PaypalButton;
